import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.27_db0@0.3.2_encoding@0.1.13_eslint_60cd5b7206f255c97fb40d687d9855ef/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}